function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "237642AF-2BF8-4AC0-9897-92467C3D8422");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Responsive_1",
  transform: "translate(-18.000000, -2327.000000)",
  fill: "#22252D"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(11.000000, 2278.000000)"
}, React.createElement("path", {
  d: "M18,49 C18.5522847,49 19,49.4477153 19,50 L19,64 C19,64.5522847 18.5522847,65 18,65 L8,65 C7.44771525,65 7,64.5522847 7,64 L7,50 C7,49.4477153 7.44771525,49 8,49 L18,49 Z M13.5,62 L12.5,62 C12.2238576,62 12,62.2238576 12,62.5 C12,62.7761424 12.2238576,63 12.5,63 L12.5,63 L13.5,63 C13.7761424,63 14,62.7761424 14,62.5 C14,62.2238576 13.7761424,62 13.5,62 L13.5,62 Z M16,51 L10,51 C9.48716416,51 9.06449284,51.3860402 9.00672773,51.8833789 L9,52 L9,60 C9,60.5128358 9.38604019,60.9355072 9.88337887,60.9932723 L10,61 L16,61 C16.5128358,61 16.9355072,60.6139598 16.9932723,60.1166211 L17,60 L17,52 C17,51.4477153 16.5522847,51 16,51 Z",
  id: "telefono"
}))));

var SvgFtPhone = function SvgFtPhone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFtPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ft-phone.8642a13e.svg";
export { ForwardRef as ReactComponent };